<template>

	 <div class="col-md-12">
      <div class="col-middle">
        <div class="text-center text-center">
          <h1 class="error-number">403</h1>
          <h2>Access denied</h2>
          <p>You don’t have access rights for this page.
          </p>
          <p><router-link :to="{path:'/'}">Back to home.</router-link></p>
        </div>
      </div>
    </div>
</template>
<script>
	export default {
    created(){
      $('body').addClass('login');
    },
	}
</script>